import { render, staticRenderFns } from "./ConsultarRequisicoes.vue?vue&type=template&id=439def0c&scoped=true"
import script from "./ConsultarRequisicoes.vue?vue&type=script&lang=js"
export * from "./ConsultarRequisicoes.vue?vue&type=script&lang=js"
import style0 from "./ConsultarRequisicoes.vue?vue&type=style&index=0&id=439def0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439def0c",
  null
  
)

export default component.exports